(function () {
  const initMainBlogTabs = () => {
    const sections = document.querySelectorAll('.section-main-blog');

    sections.forEach((section) => {
      const tabsWrapper = section.querySelector('[data-main-blog-tabs-section]');

      if (!tabsWrapper) return;

      const tabs = tabsWrapper.querySelectorAll('.main-blog__tab');
      const posts = section.querySelectorAll('.blog-articles__article[data-article-tags]');
      const emptyMessage = section.querySelector('[data-main-blog-empty-message]');

      const applyFilter = (selectedTag) => {
        let visibleCount = 0;

        posts.forEach((post) => {
          const tags = (post.dataset.articleTags || '')
            .split(',')
            .map((tag) => tag.trim())
            .filter(Boolean);
          const isVisible = selectedTag === 'all' || tags.includes(selectedTag);

          post.classList.toggle('blog-articles__article--hidden', !isVisible);

          if (isVisible) visibleCount += 1;
        });

        if (emptyMessage) {
          emptyMessage.classList.toggle('hidden', visibleCount > 0);
        }
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const selectedTag = tab.dataset.filterTag || 'all';

          tabs.forEach((item) => {
            const isActive = item === tab;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });

          applyFilter(selectedTag);
        });
      });
    });
  };

  initMainBlogTabs();

  document.addEventListener('shopify:section:load', initMainBlogTabs);
})();
